export const enum GAEvents {
  WIZARD = "wizard",
  BUTTON = "button",
  CTA = "cta",
  SCROLL = "scroll",
  PHONE = "phone",
}
